import i18n from '@/i18n/i18n';
import { IconsToGoals } from '@/maps/IconsToGoals';

/**
 * Returns an array for search:
 * - If goals match: [originalTerm, "Goal1 Goal2 Goal3"]
 * - If no match: [originalTerm]
 */
export function translateGoalSearchTerm(searchTerm: string): string[] {
  if (!searchTerm) return [searchTerm];
  const term = searchTerm.toLowerCase();

  const matchedGoals = Object.keys(IconsToGoals).filter((goalName) => {
    const hebrewName = i18n.t(goalName).toLowerCase();
    return hebrewName.includes(term);
  });

  if (matchedGoals.length > 0) {
    return [searchTerm, matchedGoals.join(' ')];
  }
  return [searchTerm];
}
